import React from 'react';
import cx from 'classnames';

export interface FormGroupProps {
  label?: React.ReactNode;
  inputComponent?: React.ReactNode;
  className?: string;
  labelClassName?: string;
  errorLabel?: React.ReactNode;
  errorLabelClassName?: string;
}

export function FormGroup({
  label,
  inputComponent,
  className,
  labelClassName,
  errorLabel,
  errorLabelClassName,
}: FormGroupProps) {
  return (
    <div className={cx(className, 'flex flex-col gap-y-1.5 w-full')}>
      <span className={cx(labelClassName, 'text-base v2-text-neutral-900')}>
        {label}
      </span>
      {inputComponent}
      <span className={cx(errorLabelClassName, 'text-xs v2-text-orange-600')}>
        {errorLabel}
      </span>
    </div>
  );
}
